import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation, Link } from 'react-router-dom';

import Step1EmailVerification from './Step1EmailVerification';
import Step2Credentials from './Step2Credentials';
import Step3PersonalInfo from './Step3PersonalInfo';
import Step4ProfileCustomization from './Step4ProfileCustomization';
import Step5Preferences from './Step5Preferences';
import { motion } from 'framer-motion';
//import { Link, useNavigate } from "react-router-dom";
import styles from './RegistrationWizard.module.css';
import logo from '../../assets/logo.png';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import {  auth, db, storage, firestore } from '../../firebase/firebase';
import { createUserWithEmailAndPassword, updateProfile, EmailAuthProvider, linkWithCredential, unlink } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';

const RegistrationWizard = ({modal, preFilledEmail, route, newUser }) => {
  const params = useParams();
  const [step, setStep] = useState(1);
  //const { notify } = useNotifications();
  const { t } = useTranslation();
  const { notify } = useNotifications();
  const navigate = useNavigate(); 
  const [loading, setLoading] = useState(false);
  const [useEmail, setEmail] = useState(preFilledEmail);
  const location = useLocation();

   useEffect(() => {
	if(location.state?.settings?.email) {
		setFormData(prev => ({ ...prev, email: location.state?.settings?.email }));
		setEmail(location.state?.settings?.email);

	}
  }, [location.state?.settings]);
 
  const [formData, setFormData] = useState({
	email: preFilledEmail,
    username: '',
    password: '',
    fullName: '',
    dob: '',
    gender: '',
    location: '',
    experience: '',
    affiliation: '',
    affiliationLogoFile: null,
	affiliationName: '',
    topics: [],
    debateStyle: 'Oxford',
    notifications: {},
    privacy: '',
    language: 'English',
    profilePicture: null,
    terms: false,
	status: 'online',
  });

  useEffect(() => {
    if (useEmail) {
		setStep(2);
	}
  }, [useEmail]);

  useEffect(() => {
	//console.log(formData)
  }, [formData]);


  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep(prev => prev - 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //setLoading(true);
	var user = null;
	var userId = null
    try {
      // Create user with email + password (email already verified)
	  if(newUser == null) {
		const userCredential = await createUserWithEmailAndPassword(auth, preFilledEmail, formData.password);
		user = userCredential.user;
		userId = user.uid;		
	  }
	  else
	  {
		await unlink(newUser, "password");
		const userCredential = EmailAuthProvider.credential(formData.email, formData.password);
		await linkWithCredential(newUser, userCredential);
		user = newUser;
		userId = user.uid;		  
	  }
	
      // Upload profile picture
      let profilePicUrl = '';
      if (formData.profilePicture) {
        const picRef = ref(storage, `users/${userId}/profile-${uuidv4()}`);
        await uploadBytes(picRef, formData.profilePicture);
        profilePicUrl = await getDownloadURL(picRef);
        await updateProfile(user, { photoURL: profilePicUrl });
      }

      // Upload affiliation logo
      let logoUrl = '';
      if (formData.affiliationLogoFile) {
        const logoRef = ref(storage, `users/${userId}/affiliation-${uuidv4()}`);
        await uploadBytes(logoRef, formData.affiliationLogoFile);
        logoUrl = await getDownloadURL(logoRef);
      }

      // Create Firestore user doc
      const userDoc = {
	    uid: userId,
        fullName: formData.fullName,
        username: formData.username,
        email: formData.email,
        dob: formData.dob,
        gender: formData.gender,
        location: formData.location,
        experience: formData.experience,
        affiliation: formData.affiliation,
		affiliationName: formData.affiliationName,
        affiliationLogoUrl: logoUrl,
        topics: formData.topics || [],
        debateStyle: formData.debateStyle,
        notifications: formData.notifications || {},
        privacy: formData.privacy,
		terms: formData.terms,
        language: formData.language,
        ratioCoin: 100,
        streak: 0,
        wins: 0,
		reputation: 1000,
        followers: 0,
		following: 0,
		friends: 0,
		status: 'online',
        profilePicture: profilePicUrl,
        createdAt: new Date().toISOString(),
		lastActivity: new Date().toISOString(),
        emailVerified: true
      };

      await setDoc(doc(firestore, 'users', userId), userDoc);
      notify('success', 'Registration completed!');
	  setLoading(true);
	  const redirect = localStorage.getItem('postLoginRedirect');
	  if (redirect) {
	   localStorage.removeItem('postLoginRedirect');
	    window.location.replace(redirect);
	  } else {
		navigate("/home"); // Redirect to protected route after login
	  }
    } catch (err) {
      //console.error(err);
      notify('error', err.message);
    }
    //setLoading(false);
  };

  const steps = {
    1: <Step1EmailVerification nextStep={nextStep} setFormData={setFormData} />,
    2: <Step2Credentials nextStep={nextStep} prevStep={prevStep} setFormData={setFormData} formData={formData} />,
    3: <Step3PersonalInfo nextStep={nextStep} prevStep={prevStep} setFormData={setFormData} formData={formData} />,
    4: <Step4ProfileCustomization nextStep={nextStep} prevStep={prevStep} setFormData={setFormData} formData={formData} />,
    5: <Step5Preferences prevStep={prevStep} OnhandleSubmit={handleSubmit} setFormData={setFormData} formData={formData} />,
  };

  if(loading) return null;

  return (
    <div className={styles.container}>
      {/*<nav className={styles.navbar}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <span className={styles.appName}>MyApp</span>
        </div>
      </nav>*/}
      <nav className={` ${modal == undefined ? styles.navbardiv : styles.navbar }`}>
        <CompactNavbar  modal={false} scrollY={0} openContact={null} openLogin={null}/>
      </nav>
	  	<motion.div
		  key={step} className={styles.stepContainer}
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{
			duration: 0.4,
			scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },}}>
      <div className={styles.card}>
        <div className={styles.stepIndicator}>
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className={`${styles.step} ${i === step ? styles.active : ''}`}/>
          ))}
        </div>
		<div className={styles.cardWith} key={step}>
			{steps[step]}
		</div>
      </div>
	  </motion.div>
    </div>
  );
};

export default RegistrationWizard;


